interface ContactInfoCardProps {
  title: string;
  description: string;
  email: string;
  icon: React.ReactNode;
}

export const ContactInfoCard = ({
  title,
  description,
  email,
  icon,
}: ContactInfoCardProps) => {
  return (
    <article className="group relative flex flex-col gap-6 p-8 md:p-10 rounded-[24px] border border-[#0D0A00]/8 bg-white transition-all duration-500 hover:border-[#0D0A00]/20 hover:-translate-y-1 hover:shadow-[0_20px_50px_-25px_rgba(13,10,0,0.18)]">
      <div className="w-10 h-10 text-[#0D0A00]/70 [&_svg]:w-full [&_svg]:h-full">
        {icon}
      </div>
      <div className="flex flex-col gap-3">
        <h3 className="text-[#0D0A00] text-[26px] md:text-[28px] font-medium tracking-[-0.025em] leading-tight">
          {title}
        </h3>
        <p className="text-[15.5px] text-[#0D0A00]/60 leading-[1.6]">
          {description}
        </p>
      </div>
      <a
        href={`mailto:${email}`}
        className="mt-auto inline-flex items-center gap-2 text-[14.5px] text-[#0D0A00] font-medium border-b border-[#0D0A00]/20 pb-1 self-start hover:border-[#F5B800] transition-colors"
      >
        {email}
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="transition-transform group-hover:translate-x-0.5">
          <path d="M2 6H10M10 6L6 2M10 6L6 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </a>
    </article>
  );
};
